import logo from "./logo.svg";
import "./App.css";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AddCalcullateClass from "./page/AddCalcullateClass";
import AddCalcullateFn from "./page/AddCalcullateFn";
import AddCalcullateFnCss from "./page/AddCalcullateFnCss";
import ProviderAppContext from "./page/App.context";
import Login from "./page/login/Login";
import {
  checkEmpty,
  clearToken,
  getDateUtilYYYYTime,
  getUserMe,
  isAdmin,
  logoutApi,
  pathRoutes,
} from "./page/service/util.service";
import Main from "./page/main/Main";
import PrivateRoute from "./page/menu/PrivateRoute";
import Summary from "./page/main/Summary";
import CheckLot from "./page/main/CheckLot";
import MainS1 from "./page/main/MainS1";
import { useEffect, useState } from "react";
import SelectUser from "./page/main/SelectUser";
import LotResualt from "./page/main/LotResualt";
import MenuTop from "./page/menu/MenuTop";
import LotResualtSet from "./page/main/LotResualt_set";
import LotSummary from "./page/main/LotSummary";
import LotSummaryNumber from "./page/main/LotSummaryNumber";
import Init from "./page/login/Init";
import LotTableResualt from "./page/main/LotTableResualt";
import Summary_Result from "./page/main/Summary_Result";
import SummaryV2 from "./page/main/SummaryV2";
import LotSummaryV2 from "./page/main/LotSummaryV2";


function App() {
  return (
    <ProviderAppContext>
      <RouteApp />
    </ProviderAppContext>
  );
}
function Menu() {
  return (
    <div style={{ padding: "20px" }}>
      <div>
        <Link to="/css">css</Link>
      </div>
      <div>
        <Link to="/fn">fn</Link>
      </div>
      <div>
        <Link to="/class">clsss</Link>
      </div>
    </div>
  );
}
function RouteApp() {
  const [admin, setAdmin] = useState(false);
  // useEffect(() => {
  //   if (isAdmin()) {
  //     setAdmin(true);
  //   } else {
  //     setAdmin(false);
  //   }
  // }, []);



  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      {/* <MenuTop /> */}
      <Routes>
        {/* <Route path="/css" element={<AddCalcullateFnCss />} />
        <Route path="/fn" element={<AddCalcullateFn />} />
        <Route path="/class" element={<AddCalcullateClass />} /> */}
        <Route path={pathRoutes.login} element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route path="/init" element={<Init />} />
        {/* <Route path="/" element={<PrivateRoute />}> */}

        {/* <Route path={pathRoutes.summary} element={<Summary />} /> */}
        <Route path={pathRoutes.summary} element={<SummaryV2 />} />
        <Route path={pathRoutes.check} element={<CheckLot />} />
        <Route path={pathRoutes.selectUser} element={<SelectUser />} />

        <Route path={pathRoutes.main} element={<Main />} />
        <Route path={pathRoutes.main_s1} element={<MainS1 />} />
        {/* <Route path={pathRoutes.lotSummary} element={<LotSummary />} /> */}
        <Route path={pathRoutes.lotSummary} element={<LotSummaryV2 />} />
        <Route
          path={pathRoutes.numberLotSummary}
          element={<LotSummaryNumber />}
        />
        <Route path={pathRoutes.lotResualt} element={<LotResualt />} />
        <Route path={pathRoutes.lotResualtSet} element={<LotResualtSet />} />
        <Route path={pathRoutes.lotResualtSet2} element={<Summary_Result />} />

        {/* </Route> */}
      </Routes>
    </BrowserRouter>
  );
}
export default App;
